/**
 * SalesDashboardContainer
 *
 *
 */

import { useState, useEffect } from 'react';
import SalesDashboardPresenter from './SalesDashboardPresenter';
import MessageAlert from 'utils';
import {
  ShopOrderApi,
  StatisticsApi,
  NoticeApi,
  InquiryApi,
  ReviewApi,
} from 'api';
import { useUserStack } from 'store';
import moment from 'moment';

// 조회할 기간
const DAY = -10;
// const DAY = -30;
const MOMENT_FORMAT = 'YYYY-MM-DD';
const startDate = moment().add(DAY, 'days').format(MOMENT_FORMAT);
const endDate = moment().format(MOMENT_FORMAT);
const startDateUnix = moment().add(DAY, 'days').startOf().unix();
const endDateUnix = moment().endOf().unix();

/**----------------------------------------
 * [Component] 홈
 * ----------------------------------------
 */
const SalesDashboardContainer = ({
  defaultShopId,
  permission,
  summaryMode,
}) => {
  /* ===== INIT ===== */
  const userInfo = useUserStack();

  /* ===== STATE ===== */
  const [currentShop, _setCurrentShop] = useState(defaultShopId ?? null);
  const [loading, setLoading] = useState(false);
  const [noticeList, setNoticeList] = useState([]);
  const [orderList, setOrderList] = useState(null);
  const [storeSales, setStoreSales] = useState(null);
  const [storeSales2, setStoreSales2] = useState(null);
  const [reviewList, setReviewList] = useState([]);
  const [inquiryList, setInquiryList] = useState([]);
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**--------------------
   * 일별 주문내역 조회
   * --------------------
   */
  const getOrderList = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await StatisticsApi.getStatistics(
        `parcel_service`,
        {
          startDate,
          endDate,
          ...(currentShop && { shopId: currentShop }),
        }
      );
      if (status !== 200) throw { message };
      setOrderList(data?.parcelSale);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**--------------------
   * 데이터 조회
   * --------------------
   */
  const getStoreSales = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await StatisticsApi.getStatistics(
        'daily',
        {
          startDate,
          endDate,
          ...(currentShop && { shopId: currentShop }),
        }
      );
      if (status !== 200) throw { message };
      setStoreSales(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**--------------------
   * 데이터 조회
   * --------------------
   */
  const getShopInformationSales = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await StatisticsApi.getStatistics(
        'shop',
        {
          // startDate: endDate,
          startDate,
          endDate,
          ...(currentShop && { shopId: currentShop }),
        }
      );
      if (status !== 200) throw { message };
      setStoreSales2(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**--------------------
   * 문의목록 조회
   * --------------------
   */
  const handleGetInquiryList = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await InquiryApi.getInquiries({
        ...(currentShop && { shop_information_id: currentShop }),
        join_tables: `["user", "product"]`,
      });
      if (status !== 200) throw { message };

      setTimeout(() => {
        setInquiryList(
          data.filter(
            (item) =>
              item.inquiry_type !== 'FAQ' && item.inquiry_answer_id === null
          )
        );
        setLoading(false);
      }, 750);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**--------------------
   * 리뷰목록 조회
   * --------------------
   */
  const getReviewList = async () => {
    try {
      const { status, message, data } = await ReviewApi.getReviews({
        ...(currentShop && { shop_information_id: currentShop }),
        // start_date: startDateUnix,
        // end_date: endDateUnix,
        join_tables: `["user", "product"]`,
      });
      if (status !== 200) throw { message };
      setReviewList(data.filter((item) => item.is_show === null));
    } catch (e) {
      MessageAlert.error(e.message);
    }
  };

  // console.log('permission: ', permission);

  /* ===== HOOKS ===== */
  useEffect(() => {
    getOrderList();
    getStoreSales();
    permission === 'ADMIN' && getShopInformationSales();
    handleGetInquiryList();
    getReviewList();
  }, []);

  /* ===== RENDER ===== */
  const props = {
    loading,
    startDate,
    endDate,
    noticeList,
    orderList,
    storeSales,
    storeSales2,
    reviewList,
    inquiryList,
    // chartData,
    currentShop,
    permission,
    // orderList,
    // productList,
    // inquiryList,
    defaultShopId,
    summaryMode,
  };
  // JSX: start
  return (
    <>
      <SalesDashboardPresenter {...props} />
    </>
  ); // JSX: end
};

SalesDashboardContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
  summaryMode: false,
};
export default SalesDashboardContainer;
